import React, {useEffect, useState} from 'react';
import useTranslate from "../../../common/hooks/useTranslate";

import { TabsProps } from './tabsProps';

import './tabs.scss';

const Tabs: React.FC<TabsProps> = ({ tabsArray, onClick, localTabId }) => {
  const [tabId, setTabId] = useState<number>(localTabId ? localTabId : 0);
  const {t} = useTranslate();

  const handleTabClick = (id: number) => {
    setTabId(id);
    onClick(id);
  };

  useEffect(() => {
    if (localTabId !== undefined)
      setTabId(localTabId);
  }, [localTabId]);

  return tabsArray.length > 0 ? (
    <div className="tabs-wrapper">
      {tabsArray.map((tab, id) => (
        tab && <div key={id} onClick={() => handleTabClick(id)} className={`tab ${tab === t('COMMUNICATIONS.WARNING') && 'warning-tab'} ${id === tabId && 'active'}`}>
          {tab}
        </div>
      ))}
    </div>
  ) : (
    <div />
  );
};

export default Tabs;
